export const PAGINATION_LIMIT = 1000;
export const PAGINATION_LIMIT_FOR_COLUMN_OPTIONS = 100;
